import { render, staticRenderFns } from "./TableSpecimensMissing.vue?vue&type=template&id=25b5bbac&scoped=true"
import script from "./TableSpecimensMissing.vue?vue&type=script&lang=js"
export * from "./TableSpecimensMissing.vue?vue&type=script&lang=js"
import style0 from "./TableSpecimensMissing.vue?vue&type=style&index=0&id=25b5bbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5bbac",
  null
  
)

export default component.exports